import {
    // FILE_UPLOAD,
    CREATE_CQCINSPECTIONAREATAXONOMY,
    RETRIEVE_CQCINSPECTIONAREATAXONOMY,
    RETRIEVESINGLE_CQCINSPECTIONAREATAXONOMY,
    UPDATE_CQCINSPECTIONAREATAXONOMY,
    DELETE_CQCINSPECTIONAREATAXONOMY,
} from "./type";
import InspectionAreaTaxonomy from "../service/InspectionAreaTaxonomy";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await InspectionAreaTaxonomy.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await InspectionAreaTaxonomy.create(data);
        dispatch({
            type: CREATE_CQCINSPECTIONAREATAXONOMY,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await InspectionAreaTaxonomy.fetchList(data);
        dispatch({
            type: RETRIEVE_CQCINSPECTIONAREATAXONOMY,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await InspectionAreaTaxonomy.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_CQCINSPECTIONAREATAXONOMY,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await InspectionAreaTaxonomy.update(data);
        dispatch({
            type: UPDATE_CQCINSPECTIONAREATAXONOMY,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await InspectionAreaTaxonomy.changeStatus(data);
//         dispatch({
//             type: UPDATE_CQCINSPECTIONAREATAXONOMY,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await InspectionAreaTaxonomy.trash(data);
        dispatch({
            type: DELETE_CQCINSPECTIONAREATAXONOMY,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};